function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v6H0v-6Z",
    style: {
      fill: "#001489"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19h30v6H0v-6Z",
    style: {
      fill: "#009a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11.32c.105,0,.201.058.249.152.593.071.905.5,1.013.999.127.584-.008,1.377-.419,2.21l1.582,2.099c.084-.039.167-.081.249-.124l.581,1.231c-2.042,1.057-4.469,1.057-6.511,0l.581-1.231c.082.043.165.085.249.124l1.582-2.099c-.412-.833-.546-1.627-.419-2.21.109-.499.42-.929,1.013-.999.049-.094.145-.152.25-.152ZM15.626,14.394c.321-.716.425-1.395.324-1.844-.09-.397-.291-.692-.69-.755v1.025l.5.5h-.4v.72l.266.354ZM14.74,11.795c-.399.063-.6.358-.69.755-.101.449.003,1.128.324,1.844l.266-.354v-.72h-.4l.5-.5s0-1.025,0-1.025ZM12.52,17.183l-.171.361.277-.074-.106-.287ZM12.381,17.701c.127.055.256.105.386.152l-.085-.232-.301.08ZM13.01,17.647l.359-.114-.103-.231c-.148-.045-.294-.096-.439-.152l.183.497ZM13.435,17.681l-.369.117.064.174c.161.047.325.089.489.124l-.184-.415ZM13.833,17.838l.395-.162-.095-.179c-.166-.024-.331-.056-.495-.094l.195.435ZM14.304,17.818l-.406.166.079.177c.18.028.36.049.541.062l-.214-.405ZM14.703,17.93l.493-.258-.071-.114c-.21.004-.42-.002-.629-.02l.207.392ZM15.282,17.808l-.504.264.089.167c.225.005.45-.002.675-.021l-.26-.41ZM15.696,17.901l.388-.266-.112-.155c-.167.027-.334.048-.503.061l.227.36ZM16.178,17.764l-.396.273.092.145c.181-.024.362-.055.541-.094l-.237-.324ZM16.539,17.75l.323-.286-.132-.16c-.143.043-.288.081-.434.114l.243.332ZM16.964,17.586l-.33.293.096.131c.157-.042.313-.091.466-.145l-.232-.279ZM17.293,17.514l.219-.264-.095-.202c-.125.056-.253.107-.382.154l.258.312ZM17.587,17.41l-.191.23.095.115c.072-.029.144-.06.215-.091l-.119-.254Z",
    style: {
      fill: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/LS.c373a9e9602e92b651a3110558feacc1.svg";
export { ForwardRef as ReactComponent };